import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as Action_App from '../actions/app'
import * as Action_Util from '../actions/util'

import BaseInfo from './app/Baseinfo'
import Comment from './app/Comment'
import Log from './app/Log'
import Developer from './app/Developer'

import {NavBar,Tabs,Icon} from 'antd-mobile'

const TabPane = Tabs.TabPane;
const objectAssign = require('object-assign');

class App extends React.Component {
    constructor(props) {
		super(props);
        const {actions,params} = props;
        actions.setScrollHeight(1.8);
        actions.getApp(params.id);
    }
    componentDidMount(){
    	document.getElementsByClassName('csm-scroll-wapper')[0].scrollTop = 0
    }
    componentDidUpdate(prevProps) {
    	document.getElementsByClassName('csm-scroll-wapper')[0].scrollTop = 0
    }
    render() {
        const {data,router,params,scrollHeight,apps} = this.props;
        const {app} = data;
        return (
            <div className='csm-body-wapper'>
                <NavBar onLeftClick={()=>router.push('/apps')}
                	rightContent={
                        <span className="csm-navbar-right-icon" onClick={()=>router.push('/apply/' + params.id)}>
                        	<Icon type="shopping-cart" />
                        </span>}>
                    { app ? app.s_name : "" }
                </NavBar>
                <Tabs className='csm-app-tabs-header' swipeable={false} defaultActiveKey="0">
                    <TabPane tab={<span><Icon type="home" />基本信息</span>}  className='csm-scroll-wapper csm-app-baseinfo' style={{height:scrollHeight}} key="0">
                        <BaseInfo data={data} apps={apps}/>
                    </TabPane>
                    <TabPane tab={<span><Icon type="team" />评论</span>}  className='csm-scroll-wapper' style={{height:scrollHeight}} key="1">
                        <Comment data={data} />
                    </TabPane>
                    <TabPane tab={<span><Icon type="setting" />历史版本</span>}  className='csm-scroll-wapper' style={{height:scrollHeight}} key="2">
                        <Log data={data} />
                    </TabPane>
                    <TabPane tab={<span><Icon type="user" />参与者</span>}  className='csm-scroll-wapper' style={{height:scrollHeight}} key="3">
                        <Developer data={data} />
                    </TabPane>
                </Tabs>
	        </div>
        )
    }

}   

function mapStateToProps(state) {
    const {app,util,apps} = state;
    return {
    	scrollHeight: util.scrollHeight,
        data: app.data,
        apps: apps
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(objectAssign({},Action_App,Action_Util), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./project/components/App.js